export const PainterMode = {
    Painting: 'painting',
    Selection: 'selection',
    Eraser: 'eraser',
    InsertText: 'insertText',
    InsertImage: 'insertImage',
    Stamp: 'stamp',
    MeasureTools: 'measureTools'
};